import { render, staticRenderFns } from "./buy_hint.vue?vue&type=template&id=55adf3da&scoped=true&"
import script from "./buy_hint.vue?vue&type=script&lang=js&"
export * from "./buy_hint.vue?vue&type=script&lang=js&"
import style0 from "./buy_hint.vue?vue&type=style&index=0&id=55adf3da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55adf3da",
  null
  
)

export default component.exports